import { StyleSheet } from "react-native";

const styles: any = StyleSheet.create({
	container: {
		backgroundColor: "#FBFAFA",
	},
	row: {
		flex: 1,
		alignItems: "center",
	},
	text: {
		fontSize: 20,
		marginBottom: 15,
		alignItems: "center",
	},
	mt: {
		marginTop: 18,
	},
	item: {
		backgroundColor: 'white',
		flexDirection:'column',
		flex: 1,
		height: 70,
		borderRadius: 5,
		padding: 6,
		marginRight: 6,
		marginLeft: 6,
		marginTop: 2,
		marginBottom: 2,
		paddingBottom: 8,
		paddingTop: 8
	},
	emptyDate: {
		height: 15,
		flex:1,
		paddingTop: 30,
		borderTopWidth: 0.5, 
		borderColor: '#e3e6e8',
		marginTop: 2,
	  },
	dayNum: {
      fontSize: 28,
      fontWeight: '200',
      color: '#7a92a5'
    },
    dayText: {
      fontSize: 14,
      fontWeight: '300',
      color: '#7a92a5',
      marginTop: -5,
      backgroundColor: 'rgba(0,0,0,0)'
    },
	dayTotalText: {
      fontSize: 12,
      fontWeight: '300',
      color: '#79a479',
	  textAlign: 'right',
      marginTop: 0,
      backgroundColor: 'rgba(0,0,0,0)'		
	},
    day: {
      width: 63,
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginTop: 2,
	  marginBottom: 5,
	  
    },
    today: {
      color: '#00adf5'
    },
	actionButtonIcon: {
		fontSize: 24
	}
});
export default styles;
